import type { RootStateOrAny } from 'react-redux'
import type { Dispatch } from 'redux'

import { basketCheckedOut, basketCheckoutClicked, basketProceedToCheckout } from 'actions/basket'
import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import { orderUpdate } from 'actions/order'
import { getIsAuthenticated } from 'selectors/auth'
import { getBasketIsFlexOrder, isBasketTransactionalOrder } from 'selectors/basket'

import type { Pricing } from '../domains/pricing'
import { checkoutTransactionalOrder } from './checkoutTransactionalOrder'

type CheckoutBasketArgs = {
  section: string
  view: string
  pricing: Pricing | null | undefined
  isFlexEnabled?: boolean
}

export const checkoutBasket =
  ({ section, view, pricing, isFlexEnabled = false }: CheckoutBasketArgs) =>
  async (dispatch: Dispatch<any>, getState: () => RootStateOrAny) => {
    const state = getState()
    const isAuthenticated = getIsAuthenticated(state)
    const isTransactionalOrder = isBasketTransactionalOrder(state)
    const shouldAllowFlexOrder = isFlexEnabled || getBasketIsFlexOrder(state)
    const transactionalOrderForNonLoggedInUser = isTransactionalOrder && !isAuthenticated

    dispatch(boxSummaryVisibilityChange(false))
    dispatch(basketCheckedOut({ view, pricing }))
    dispatch(basketCheckoutClicked(section))

    if (transactionalOrderForNonLoggedInUser) {
      dispatch(basketProceedToCheckout())

      return
    }

    if (isTransactionalOrder) {
      dispatch(checkoutTransactionalOrder(shouldAllowFlexOrder))

      return
    }

    dispatch(orderUpdate(shouldAllowFlexOrder))
  }
